import {Person} from '../TimesheetsCalendarTypes';
import {CalendarEventType} from './CalendarEventsFetch';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';
import {differenceInMinutes} from 'date-fns';
import {getEndDate, getStartDate} from '../TimesheetsCalendarUtil';
import {markEventAsConvertedType} from './useConvertedEventTracking';
import {EVENT_ID, dispatch} from '../../../../../containers/event_manager';
export const openTimeRegModal = (
	person: Person,
	calendarEvent: CalendarEventType,
	markEventAsConverted: markEventAsConvertedType,
	sideModalOpen: boolean,
	clearSearchEntity?: boolean
): void => {
	const start = getStartDate(calendarEvent) || new Date();
	const end = getEndDate(calendarEvent) || new Date();
	const duration = differenceInMinutes(end, start);

	const calendarEventName = calendarEvent?.name;

	const taskIdRegex = /(?:^|\s)T-?(\d{1,6})(?:$|\s)/i;
	const taskMatch = calendarEventName ? taskIdRegex.exec(calendarEventName) : null;
	const taskId = taskMatch ? taskMatch[1] : undefined;

	const taskProjectIdRegex = /(?:^|\s)P-?(\d{1,6})(?:$|\s)/i;
	const projectMatch = calendarEventName ? taskProjectIdRegex.exec(calendarEventName) : null;
	const projectId = projectMatch ? projectMatch[1] : undefined;
	const companyProjectId = taskId || !projectId ? undefined : `P-${projectId}`;

	const initialState = {
		minutes: duration,
		date: start,
		note: calendarEventName,
		callAttention: true,
		clearSearchEntity,
	};

	const modalData = {
		personId: person.id,
		companyTaskId: taskId,
		companyProjectId: companyProjectId,
		initialState: initialState,
		onCreateSuccessCallbacks: [() => markEventAsConverted(calendarEvent?.id)],
	};
	if (sideModalOpen) {
		dispatch(EVENT_ID.TIMESHEET_SHOW_SIDE_MODAL, initialState);
	} else {
		showModal({
			type: MODAL_TYPE.CREATE_TIME_REGISTRATION,
			personLabel: person.fullName,
			...modalData,
		});
	}
};

export const openCreateTaskModal = (
	person: Person,
	calendarEvent: CalendarEventType,
	markEventAsConverted: markEventAsConvertedType
): void => {
	const start = getStartDate(calendarEvent) || new Date();
	const end = getEndDate(calendarEvent) || new Date();

	const duration = differenceInMinutes(end, start);

	let description = calendarEvent?.description ? '<p>' + calendarEvent?.description + '</p>' : null;
	if (description) {
		description = description.replace(/(\r\n|\r|\n)/g, '<br>');
	}

	showModal({
		type: MODAL_TYPE.TASK_LOCATION,
		viewerId: person.id,
		currentProjectGroupId: null,
		currentProjectGroupName: null,
		name: calendarEvent?.name,
		description: description,
		startYear: start.getFullYear(),
		startMonth: start.getMonth() + 1,
		startDay: start.getDate(),
		deadlineYear: end.getFullYear(),
		deadlineMonth: end.getMonth() + 1,
		deadlineDay: end.getDate(),
		estimate: duration,
		assignedPersons: [person.id],
		roleId: person.role?.id,
		onCreateSuccess: () => markEventAsConverted(calendarEvent?.id),
	});
};
